import React from 'react'
import { StrategiesList } from './list/page'
export const StrategiesPage = () => {
  return <StrategiesList />
}
